import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { active: { type: Number, default: 0 } }

  connect() {
    this.showTab(this.activeValue)
  }

  // A lazy-loaded Turbo Frame (KT-902) can swap a panel's content in after
  // the user has already switched tabs -- reapply the current tab's
  // visibility to any panel that connects (or reconnects) so a late frame
  // load can't silently hide the tab the user is looking at.
  panelTargetConnected(panel) {
    panel.classList.toggle("hidden", this.panelTargets.indexOf(panel) !== this.activeValue)
  }

  select(event) {
    event.preventDefault()
    const index = parseInt(event.currentTarget.dataset.tabsIndexParam, 10)
    this.showTab(index)
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      const selected = i === index

      if (selected) {
        tab.classList.add("border-indigo-500", "text-indigo-600", "dark:text-indigo-400")
        tab.classList.remove("border-transparent", "text-gray-500", "dark:text-gray-400", "hover:text-gray-700", "dark:hover:text-gray-300", "hover:border-gray-300")
      } else {
        tab.classList.remove("border-indigo-500", "text-indigo-600", "dark:text-indigo-400")
        tab.classList.add("border-transparent", "text-gray-500", "dark:text-gray-400", "hover:text-gray-700", "dark:hover:text-gray-300", "hover:border-gray-300")
      }

      // KT-848: only tabs that already declare aria-selected opt into this --
      // slack_archive/channels/show.html.erb's tab buttons carry no
      // aria-selected attribute today and are left exactly as they were.
      if (tab.hasAttribute("aria-selected")) {
        tab.setAttribute("aria-selected", selected ? "true" : "false")
      }
    })

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index)
    })

    this.activeValue = index
  }
}
